export default __webpack_public_path__ + "static/media/video4.b497c184.mp4";